import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mapTo } from 'rxjs/operators';
import { GenesysCloudPlatformApiService } from '../../common/services/genesys-cloud-platform-api.service';
import { NotificationChannel } from '../models/notification.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationApiService {
  static readonly NotificationChannelPath = 'api/v2/notifications/channels';

  constructor(private readonly api: GenesysCloudPlatformApiService) {
  }

  createNotificationChannel$(): Observable<NotificationChannel> {
    return this.api.post$(NotificationApiService.NotificationChannelPath, null);
  }

  subscribeToChannel$(userId: string, channelId: string, ...topics: string[]): Observable<string[]> {
    const path = `api/v2/notifications/channels/${channelId}/subscriptions`;
    const body = topics.map(topic => ({ id: topic }));

    return this.api.post$(path, body).pipe(
      mapTo(topics)
    );
  }
}

